import type { PropsWithChildren } from 'react';

import { SingleColumnLayout } from '../SingleColumnLayout/SingleColumnLayout';

import styles from './Author.module.scss';

type Props = PropsWithChildren;

export function Author({ children }: Props) {
	return (
		<SingleColumnLayout className={styles.mainLayout} contentClassName={styles.contentLayout} noBackground={true}>
			{children}
		</SingleColumnLayout>
	);
}
